module.exports = __webpack_public_path__ + "static/media/quadcopter_logo.340807ab.png";